let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("88cza")).then(() => parcelRequire('7eY2Z'));